import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type DeleteCBQScenarioResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: unknown;
};

export const DeleteCBQScenario = async (
  scenarioId: string
): Promise<DeleteCBQScenarioResponse> => {
  try {
    const response = await axios.delete(`/admin/cbq/scenarios/${scenarioId}`);
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
